'use strict';
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

Groupon.Widgets.BackToTopButton = (function() {
  function BackToTopButton() {
    this.bind = bind(this.bind, this);
    this.showOrHide = bind(this.showOrHide, this);
    this.requestTick = bind(this.requestTick, this);
    var fn;
    if (!(this.$back2top = $('#ls-back-to-top')).length) {
      return;
    }
    this.offset = $('.header-v2 header.header').height() * 1.5;
    this.visible = false;
    if (window.requestAnimationFrame) {
      fn = this.requestTick;
    } else {
      fn = this.showOrHide;
    }
    $(window).on('scroll', _.throttle(fn, 1000));
    this.bind();
  }

  BackToTopButton.prototype.requestTick = function() {
    return window.requestAnimationFrame(this.showOrHide);
  };

  BackToTopButton.prototype.showOrHide = function() {
    var threshold, y;
    y = window.scrollY || window.pageYOffset;
    threshold = y > this.offset;
    if (threshold && !this.visible) {
      this.$back2top.css({
        'z-index': 200
      });
      this.$back2top.addClass('ls-back-to-top-visible').attr('aria-hidden', 'false');
      return this.visible = true;
    } else if (this.visible && !threshold) {
      this.$back2top.attr('aria-hidden', 'true').removeClass('ls-back-to-top-visible');
      return this.visible = false;
    }
  };

  BackToTopButton.prototype.bind = function() {
    this.$back2top.on('click', (function(_this) {
      return function() {
        return $('body, html').animate({
          scrollTop: 0
        }, 500, function() {
          return _this.$back2top.attr('aria-hidden', 'true');
        });
      };
    })(this));
    return this.$back2top.on('transitionend', (function(_this) {
      return function() {
        if (_this.$back2top.css('opacity') === '0') {
          return _this.$back2top.css({
            'z-index': -1
          });
        }
      };
    })(this));
  };

  return BackToTopButton;

})();

